
const cadastroGridConfig = {
  idField: "idCadastro",
  columns: [
    { header: "Nome", field: "NOME" },
    { header: "Celular", field: "CELULAR" },
    { header: "E-mail", field: "EMAIL" }
  ]
};

export default cadastroGridConfig;